






import { Component, Vue } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import store from "@/store";
@Component({
  components: {}
})
export default class ResidentApprovalPdfPage extends Vue {
  requestId: string = "";
  email: string = "";
  fileUrl: any = "";
  isPdfReady: boolean = false;
  isDataReady: boolean = false;
  constructor() {
    super();
  }

  created() {
    this.requestId = this.$route.params.requestId;
    this.email = this.$route.params.email;
    if (this.requestId && this.email) {
      this.onGetIshurToshavByEmail();
    }
  }

  onGetIshurToshavByEmail() {
    this.appEnv.isBusy = true;
    this.isPdfReady = false;
    apiService
      .getFile(
        "Approvment/GetIshurToshavByEmail",{requestId:this.requestId,email:this.email}
      )
      .then(res => {
        this.fileUrl = URL.createObjectURL(res);
        this.isPdfReady = true;
        this.isDataReady = true;
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.isDataReady = true;
        this.appEnv.isBusy = false;
      });
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
